<harp-skip-nav></harp-skip-nav>
<harp-spinner></harp-spinner>
<harp-header></harp-header>

<div class="harp-reg-page" id="main" role="main" tabindex="-1">
  <div class="harp-reg-page-header">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="harp-page-title">Create an Account</h1>
          <p class="harp-page-subtitle">HCQIS Access Roles and Profile</p>
          <app-workflow></app-workflow>
        </div>
      </div>
    </div>
  </div>
  <div class="harp-reg-page-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>

<harp-footer [showUserFeedbackLink]="false"></harp-footer>
